import Vue from 'vue';
import ConfirmDialog from './ConfirmDialog.vue';

Vue.component('confirm-dialog', ConfirmDialog);
